import type { PageContext } from 'vike/types'

import { DEFAULT_LOCALE } from '../utils/i18n'

export default function lang(pageContext: PageContext): string {
  return pageContext.locale ?? DEFAULT_LOCALE
}
